<template>
  <div class="con">
    <div class="top">
      <div class="lf">
        <img src="/static/images/logo.png" alt />
        <span>财富风险管理风险</span>
      </div>
      <div class="rt">
        <a href="javascript:void(0)" @click="download">确认下载</a>
      </div>
    </div>
    <div class="mid">
      <img :src="info.imgurl" class="people-img" />
      <div class="txt">
        <div class="lf">
          <h1>{{username}}</h1>
          <p>邀请你加入{{info.title}}</p>
          <p>{{info.introduction}}</p>
        </div>
        <div class="rt">
          <!--<img src="/static/images/erweima.png" alt="">-->
        </div>
      </div>
    </div>
    <div class="bottom">
      <input type="text" v-model="phone" placeholder="请输入手机号码" />
    </div>
    <div class="bottom">
      <input type="text" v-model="code" placeholder="请输入验证码" />
      <a href="javascript:void(0)" @click="getCode">{{msg}}</a>
    </div>
    <a href="javascript:void(0)" class="save" @click="save">确认邀请</a>
  </div>
</template>

<script>
export default {
  name: "familyimgDetaile",
  data() {
    return {
      hUrl: "http://app.hkcfra.cn",
      id: "",
      token: "",
      username: "", //用户名
      info: {}, // 详情
      seconds: 60,
      msg: "获取验证码",
      code: "", //获取验证码
      inviteid: "", //邀请id
      phone: "", //手机号
      inviteid: "", //邀请id
    };
  },
  mounted() {
    if (this.getUrlParamURLys("id")) {
      this.id = this.getUrlParamURLys("id");
      this.token = this.getUrlParamURLys("token");
      this.username = this.getUrlParamURLys("username");
      this.getinfo();
    }
    if (this.getUrlParamURLys("inviteid")) {
      this.inviteid = this.getUrlParamURLys("inviteid");
    }
  },
  methods: {
    // 判读设备
    IsAndroid: function () {
      var userAgentInfo = navigator.userAgent;
      var Agents = new Array("iPhone", "iPad", "iPod");
      //alert(userAgentInfo)
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    },
    // 点击下载
    download: function () {
      window.location.href =
        "https://a.app.qq.com/o/simple.jsp?pkgname=com.ylean.hengtong";
      // var flag=this.IsAndroid();
      // if(flag==true){
      //   window.location.href="https://apps.apple.com/cn/app/id1525053470"

      // }else{
      //   window.location.href="https://a.app.qq.com/o/simple.jsp?pkgname=com.ylean.hengtong"
      // }
    },
    // 获取验证码
    getCode: function () {
      var _this = this;
      if (_this.phone == "") {
        Yeffect.mAlert("手机号不能为空");
        return false;
      } else if (_this.send == false) {
        Yeffect.mAlert("已发送，请耐心等待");
        return false;
      }
      _this.seconds = 60;
      _this.call_net(
        "POST",
        "/api/app/sms/send",
        { smstype: 4, phone: _this.phone },
        function (data) {
          if (data.code === 200) {
            Yeffect.mAlert("发送成功");
            _this.send = false;
            //debugger;
            _this.overTime();
          } else {
            Yeffect.mAlert(data.desc);
          }
        }
      );
    },
    overTime: function () {
      // debugger;
      var self = this;
      if (this.seconds > 1) {
        this.seconds--;
        this.msg = this.seconds + "秒";
        setTimeout(function () {
          self.overTime();
        }, 1000);
      } else {
        this.msg = "获取验证码";
        this.send = true;
      }
    },

    // 获取详情
    getinfo: function () {
      var _this = this;

      _this.call_net(
        "POST",
        "/api/app/invite/template/info",
        { id: _this.id },
        function (data) {
          if (data.code === 200) {
            _this.info = data.data;
            _this.info.imgurl = _this.hUrl + _this.info.imgurl;
          } else {
            Yeffect.mAlert(data.desc);
          }
        }
      );
    },
    // 确认邀请
    save: function () {
      var _this = this;
      var obj = {};
      obj.code = _this.code;
      obj.phone = _this.phone;
      obj.inviteid = _this.inviteid;
      _this.call_net("POST", "/api/app/invite/accept", obj, function (data) {
        if (data.code === 200) {
          Yeffect.mAlert("成功");
          setTimeout(function () {
            _this.code = "";
            _this.phone = "";
            _this.inviteid = "";
          }, 1000);
        } else {
          Yeffect.mAlert(data.desc);
        }
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.con {
  position: absolute;
  width: 100%;
  height: 100%;
  background: url("/static/images/share-bg.png") no-repeat center top;
  padding: 0.3rem;
  box-sizing: border-box;
}
.top {
  overflow: hidden;
}
.top .lf {
  float: left;
}
.top .lf img {
  display: inline-block;
  width: 0.76rem;
  height: 0.76rem;
  vertical-align: middle;
}
.top .lf span {
  display: inline-block;
  font-size: 0.3rem;
  vertical-align: middle;
  margin-left: 0.1rem;
}
.top .rt {
  float: right;
}
.top .rt a {
  width: 1.45rem;
  height: 0.64rem;
  border-radius: 0.1rem;
  background-color: #d7b177;
  text-align: center;
  line-height: 0.64rem;
  font-size: 0.26rem;
  color: #fff;
  display: block;
}
.mid {
  display: block;
  width: 5.26rem;
  height: 7.8rem;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 0.2rem;
  margin-top: 0.87rem;
  margin-bottom: 0.4rem;
}
.mid .people-img {
  display: block;
  width: 100%;
  height: 6.58rem;
  border-radius: 0.1rem;
}
.mid .txt {
  padding: 0.2rem;
  padding-top: 0.1rem;
}
.mid .txt .lf {
  float: left;
}
.mid .txt .lf h1 {
  font-size: 0.28rem;
  color: #333;
}
.mid .txt .lf p {
  font-size: 0.24rem;
  color: #666;
}
.mid .rt {
  float: right;
  margin-top: 0.1rem;
}
.mid .rt img {
  display: block;
  width: 0.77rem;
  height: 0.75rem;
}
.bottom {
  width: 5.25rem;
  margin: 0 auto;
  height: 0.64rem;
  background-color: #fff;
  margin-top: 0.3rem;
  font-size: 0;
  border-radius: 0.1rem;
  overflow: hidden;
}
.bottom input {
  display: inline-block;
  width: 3.6rem;
  border: none;
  outline: none;
  height: 0.64rem;
  padding-left: 0.28rem;
  color: #999;
  font-size: 0.26rem;
}
.bottom a {
  display: inline-block;
  width: 1.37rem;
  height: 0.64rem;
  line-height: 0.64rem;
  background-color: #d7b177;
  font-size: 0.26rem;
  text-align: center;
  color: #fff;
}
.save {
  display: block;
  margin: 0 auto;
  width: 5.25rem;
  height: 0.64rem;
  line-height: 0.64rem;
  background-color: #d7b177;
  font-size: 0.26rem;
  text-align: center;
  color: #fff;
  border-radius: 0.1rem;
  margin-top: 0.3rem;
}
</style>



// WEBPACK FOOTER //
// src/components/invitationShare.vue